<template>
    <div class="modal fade" tabindex="-1" role="dialog" id="show-change-development-breakdown-modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <form @submit.prevent="submit">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                &times;
                            </span>
                        </button>

                        <h4 class="modal-title">
                            Change Development Breakdown ({{ formattedMonth }})
                        </h4>
                    </div>

                    <loading-spinner v-if="loading"></loading-spinner>

                    <div v-else class="modal-body">
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th class="col-xs-4">
                                    Subscriber
                                </th>

                                <th class="col-xs-2">
                                    Portal
                                </th>

                                <th class="col-xs-3">
                                    Price
                                </th>

                                <th class="col-xs-3">
                                    Status
                                </th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr v-for="subscriptionPeriod in subscriptionPeriods.data">
                                <td class="table__ellipsis">
                                    <router-link
                                            :to="'/' + subscriptionPeriod.subscription.subscriber_type + '/' + subscriptionPeriod.subscription.subscriber_id + '/subscriptions/' + subscriptionPeriod.subscription.id"
                                            @click.native="hide"
                                    >
                                        {{ subscriptionPeriod.subscription.subscriber.name }}
                                    </router-link>
                                </td>

                                <td class="table__ellipsis">
                                    <router-link
                                            :to="'/portals/' + subscriptionPeriod.subscription.portal.id"
                                            @click.native="hide"
                                    >
                                        {{ subscriptionPeriod.subscription.portal.name }}
                                    </router-link>
                                </td>

                                <td>
                                    {{ subscriptionPeriod.price | price }}
                                </td>

                                <td>
                                    <span
                                        v-if="isStarting(subscriptionPeriod) && hasStarted(subscriptionPeriod) && subscriptionPeriod.is_first"
                                        class="label label-success" style="background-color: #62d26f"
                                    >
                                        New (actual)
                                    </span>

                                    <span
                                        v-if="isStarting(subscriptionPeriod) && !hasStarted(subscriptionPeriod) && subscriptionPeriod.is_first"
                                        class="label label-success" style="background-color: #37c5ab"
                                    >
                                        New (expected)
                                    </span>

                                    <span
                                            v-if="isStarting(subscriptionPeriod) && !subscriptionPeriod.is_first"
                                            class="label label-success" style="background-color: #a4cf30"
                                    >
                                        Renewed
                                    </span>

                                    <span
                                            v-if="isEnding(subscriptionPeriod) && subscriptionPeriod.subscription.has_automatic_renewal"
                                            class="label label-success" style="background-color: #eec300"
                                    >
                                        Ending (with renewal)
                                    </span>

                                    <span
                                            v-if="isEnding(subscriptionPeriod) && !subscriptionPeriod.subscription.has_automatic_renewal"
                                            class="label label-warning" style="background-color: #e8384f"
                                    >
                                        Ending (without renewal)
                                    </span>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        <resource-pager :pagination="subscriptionPeriods.meta" @navigate="navigate"/>

                        <br>

                        <div class="text-center">
                            <i>
                                In this chart, the actual price of the subscription periods that start and end in a
                                month is used.
                            </i>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import moment from 'moment'
    import LoadingSpinner from '@/components/Layout/LoadingSpinner'
    import ResourcePager from '@/components/Utilities/Pagination/ResourcePager'

    export default {
        components: {ResourcePager, LoadingSpinner},

        props: {
            month: {
                required: true
            },

            filters: {
                required: true
            }
        },

        data() {
            return {
                subscriptionPeriods: null,

                page: 1,

                loading: true
            }
        },

        mounted() {
            this.listenForClose()

            this.load()
        },

        watch: {
            month() {
                this.load()
            }
        },

        computed: {
            formattedMonth() {
                return moment(this.month).format('YYYY-MM')
            },

            requestFilters() {
                let filters = {}

                if (this.filters.find(filter => filter.dimension === 'portal_id')) {
                    filters.portal_id = this.filters.find(filter => filter.dimension === 'portal_id').value
                }

                if (this.filters.find(filter => filter.dimension === 'user_id')) {
                    filters.user_id = this.filters.find(filter => filter.dimension === 'user_id').value
                }

                if (this.filters.find(filter => filter.dimension === 'subscriber_type')) {
                    filters.subscriber_type = this.filters.find(filter => filter.dimension === 'subscriber_type').value
                }

                return filters
            }
        },

        methods: {
            load() {
                this.loading = true

                http.get('/api/v1/subscription-periods', {
                    'filter[change_month]': this.month,
                    page_size: 10,
                    page: this.page,
                    ...this.requestFilters
                }).then(response => {
                    this.subscriptionPeriods = response.data

                    this.loading = false
                })
            },

            hide() {
                $(this.$el).modal('hide')
            },

            navigate(page) {
                this.page = page

                this.load()
            },

            listenForClose() {
                $(this.$el).on('hidden.bs.modal', this.reset)
            },

            reset() {
                this.page = 1
            },

            isStarting(subscriptionPeriod) {
                return moment(subscriptionPeriod.starts_at).isBetween(
                    moment(this.month),
                    moment(this.month).endOf('month'),
                    undefined,
                    '[]'
                )
            },

            isEnding(subscriptionPeriod) {
                return moment(subscriptionPeriod.ends_at).isBetween(
                    moment(this.month),
                    moment(this.month).endOf('month'),
                    undefined,
                    '[]'
                )
            },

            hasStarted(subscriptionPeriod) {
                return moment(subscriptionPeriod.starts_at).isBefore()
            }
        }
    }
</script>
